import { MutationTree } from 'vuex';
import { IRootState } from '@/store/state';
import * as MT from './mutationTypes';
import Snackbar from '@/models/Snackbar';
import { Template } from '@/modules/amDashboard/types';

/**
 * --------------------------------------------------
 *	Root Mutations
 * --------------------------------------------------
 **/
export const RootMutations: IRootMutations = {
  [MT.SET_SNACKBAR]: (state: IRootState, snackbar: Snackbar) =>
    (state.snackbar = snackbar),
  [MT.SET_GLOBAL_SOURCE]: (state: IRootState, globalSource: string) =>
    (state.globalSource = globalSource),
  [MT.SET_BATCH_ID]: (state: IRootState, batchId: string) =>
    (state.batchId = batchId),
  [MT.SET_BULK_SUBMISSION_TEMPLATE_DETAILS]: (
    state: IRootState,
    templates: Template[]
  ) => (state.bulkSubmissionTemplateDetails = templates),
  [MT.SET_VALIDATING_ENTITY_ACCESS]: (
    state: IRootState,
    validatingEntityAccess: boolean
  ) => (state.validatingEntityAccess = validatingEntityAccess)
};

/**
 * --------------------------------------------------
 *	Root Mutations Interface
 * --------------------------------------------------
 **/
export interface IRootMutations extends MutationTree<IRootState> {
  [MT.SET_SNACKBAR]: (state: IRootState, snackbar: Snackbar) => void;
  [MT.SET_GLOBAL_SOURCE]: (state: IRootState, globalSource: string) => void;
  [MT.SET_BATCH_ID]: (state: IRootState, batchId: string) => void;
  [MT.SET_BULK_SUBMISSION_TEMPLATE_DETAILS]: (
    state: IRootState,
    templates: Template[]
  ) => void;
  [MT.SET_VALIDATING_ENTITY_ACCESS]: (
    state: IRootState,
    validatingEntityAccess: boolean
  ) => void;
}
